module.exports = __webpack_public_path__ + "img/SUPEROK_1.105f12ea.jpg";